import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from 'react-fade-in'

import { convertCountriesToString } from '../../../helpers/country/country'
import { Metrics } from './metrics/metrics-component'
import { Tags } from './tags/tags-component'
import { RecipeCard } from './recipe-card/recipe-card-component'
import { MostRecentVideoComponent } from '../home/most-recent-video/most-recent-video-component'
import * as S from './recipe-styled'

const RecipeComponent = ({ recipe }) => (
  <FadeIn>

    <S.Header>

      <S.Country>{convertCountriesToString(recipe.countries)}</S.Country>

      <S.Title>{recipe.title}</S.Title>

      <Metrics
        prepTime={recipe.prepTime}
        cookTime={recipe.cookTime}
        servings={recipe.yieldServings}
      />

      <S.Description>{recipe.description}</S.Description>

      <Tags
        tags={recipe.tags}
      />

    </S.Header>

    <S.VideoContainer>
      <MostRecentVideoComponent
        videoSrc={recipe.video}
        width="100vw"
        title={recipe.title}
      />
    </S.VideoContainer>

    <RecipeCard
      title={recipe.title}
      image={recipe.image}
      ingredients={recipe.ingredients}
      directions={recipe.directions}
      notes={recipe.notes}
      nutritionFacts={recipe.nutritionFacts}
      recipeSlugLinks={recipe.recipeSlugLinks}
    />

  </FadeIn>
)

RecipeComponent.propTypes = {
  recipe: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    countries: PropTypes.array.isRequired,
    prepTime: PropTypes.string.isRequired,
    cookTime: PropTypes.string.isRequired,
    yieldServings: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    video: PropTypes.string,
    description: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
    ingredients: PropTypes.array.isRequired,
    directions: PropTypes.array.isRequired,
    notes: PropTypes.array,
    nutritionFacts: PropTypes.object.isRequired,
    recipeSlugLinks: PropTypes.array.isRequired,
  }),
}

export { RecipeComponent }